import { SButton1, SButton2, SButton3, SButton4 } from './SButton';
import { SBox, SBox2 } from './SBox';
import { SideInfoContainer, SideInfoWrap } from './SideInfoStyle';
import { useReportContext } from '../context/DetailContext';
import styled from 'styled-components';
import { useEffect, useState } from 'react';
import LoanInfoService from '../service/LoanInfo';
import InterestSerivce from '../service/Interest';
import { ANavInfo, ENaviInfo, NNaviInfo, PNavInfo } from '../page/detail/data';

export const AFileList = (linkSet: any, caseInfo: any, statusServeryButtonOn: boolean, deliveryButtonOn: boolean) => [
  {
    content: '매각물건명세서',
    icon: 'invoice.svg',
    link: linkSet.buttonLink.assetDetail,
  },
  {
    content: '감정평가서',
    icon: 'search.svg',
    link: linkSet.buttonLink.appraisal,
  },
  {
    content: '현황조사서',
    icon: 'check.svg',
     link:
    statusServeryButtonOn && caseInfo?.iidx
      ? linkSet?.buttonLink?.statusServery || `/statusServey?iidx=${caseInfo.iidx}`
      : '',
  },
  {
    content: '문건/송달내역',
    icon: 'letter.svg',
    link: linkSet.buttonLink.documentsHistory,
  },
  {
    content: '토지등기',
    icon: 'layer.svg',
    link: linkSet.buttonLink.landRegister,
  },
  {
    content: '첨부파일',
    icon: 'document.svg',
    link: '첨부파일',
  },
];

export const ACommonList = ( caseInfo: any, itemDetailButtonOn: boolean, casDetailButtonOn: boolean, dateDetailButtonOn: boolean) => [
    {
      refer: '대법원',
      title: '물건상세',
      color: '#0052BD',
      link: itemDetailButtonOn ? `/itemDetail?iidx=${caseInfo.iidx}` : '',
    },
    {
      refer: '대법원',
      title: '사건내역',
      color: '#0052BD',
      link: casDetailButtonOn ? `/incidentDetail?iidx=${caseInfo.iidx}` : '',
    },
    {
      refer: '대법원',
      title: '기일내역',
      color: '#0052BD',
      link: dateDetailButtonOn ? `/dateDetail?iidx=${caseInfo.iidx}` : '',
    },
];


export const Poutlink = (linkSet: any) => [
    {
      img: '/assets/images/icon/icon_landUse.svg',
      title: '토지이음',
      subTitle: '토지이용계획열람',
      link: linkSet.landUsePlanLink,
    },
    {
      img: '/assets/images/icon/icon_naverLand.svg',
      title: '네이버페이 부동산',
      subTitle: '네이버 매물',
      link: '',
    },
    {
      img: '/assets/images/icon/icon_naverLand.svg',
      title: '네이버페이 부동산',
      subTitle: '네이버 단지정보',
      link: linkSet?.naverComplexLink,
    },
];
  
export interface PFileItem {
  content: string;
  icon: string;
  link: string;
  isModal?: boolean;
    disabled?: boolean;
}

export const PFileList = (linkSet: any): PFileItem[] => [
  {
    content: '재산명세서',
    icon: 'invoice.svg',
    link: linkSet?.buttonLink?.propertyStat || '',
  },
  {
    content: '감정평가서',
    icon: 'search.svg',
    link: linkSet?.buttonLink?.appraisal || '',
  },
  {
    content: '건물등기',
    icon: 'building.svg',
    link: linkSet?.buttonLink?.buildingRegister || '',
  },
  {
    content: '토지등기',
    icon: 'layer.svg',
    link: linkSet?.buttonLink?.landRegister || '',
  },
  {
    content: '압류재산정보',
    icon: 'lock.svg',
    link: linkSet?.buttonLink?.assetDetail || '',
  },
  {
    content: '첨부파일',
    icon: 'document.svg',
    link: '첨부파일',
    isModal: true,
  },
];

interface SideInfoProps {
  linkSet: any;
  caseInfo: any;
  attachmentFile?: any;
  setShowFileModal: (value: boolean) => void;
  tab?: string;
  iidx?: string;
}

const SideInfo = ({
  linkSet,
  caseInfo,
  attachmentFile,
  setShowFileModal,
  tab,
  iidx,
}: SideInfoProps) => {
   const [active, setActive] = useState(false);
  const { type, setType } = useReportContext();
  const [positions, setPositions] = useState<number[]>([]);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [deliveryButtonOn, setDeliveryButtonOn] = useState<boolean>(false);
  const [statusServeryButtonOn, setStatusServeryButtonOn] =
    useState<boolean>(false);
  const [list, setList] = useState(['']);
  const [isLike, setIsLike] = useState<boolean>(false);
  const [showLikeModal, setShowLikeModal] = useState<boolean>(false);
  const [mode, setMode] = useState<string>('add');

  const [selectedItem, setSelectedItem] = useState({
    iidx: 0,
    group: '',
    group_idx: 0,
    level: 0,
    memo: '',
  });
  const [activeItem, setActiveItem] = useState<number | null>(null);

  useEffect(() => {
    const path = window.location.pathname.split('/');
    if (path[1] === 'scheduled') {
      setType('s');
    }
  }, []);

  const checkIsLike = async () => {
    try {
      const res = await InterestSerivce.check(caseInfo.iidx);
      setIsLike(res.data.is_like);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (type !== 's') {
      checkIsLike();
    }
  }, []);

  const disLike = async (iidx: number) => {
    try {
      const res = await InterestSerivce.dislike(iidx);
      setActiveItem(null);
      alert('관심물건에서 삭제되었습니다.');
      checkIsLike();
    } catch (error) {
      console.error('dislike 함수에서 에러 발생:', error);
    }
  };

  const handleDisLikeItem = (iidx: number) => {
    if (window.confirm('관심물건에서 삭제하시겠습니까?')) {
      disLike(iidx);
    }
  };



  const getDeliveryData = async (iidx: number) => {
    try {
      const res = await LoanInfoService.documentDelivery(iidx);
      if (
        res.data &&
        res.data.date_list.length > 0 &&
        res.data.date_list2.length > 0
      ) {
        setDeliveryButtonOn(true);
      }
    } catch (e) {
      console.error(e);
    }
  };
  const getStatusServeyData = async (iidx: number) => {
    try {
      const res = await LoanInfoService.statusServey(iidx);
      if (res.data && res.data.top) {
        setStatusServeryButtonOn(true);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (type === 's') {
      return;
    }
    if (iidx) {

      getDeliveryData(Number(iidx));
      getStatusServeyData(Number(iidx));
    }
  }, [type]);

  // const AFileList = [
  //   {
  //     content: '매각물건명세서',
  //     icon: 'invoice.svg',
  //     link: linkSet.buttonLink.assetDetail,
  //   },
  //   {
  //     content: '감정평가서',
  //     icon: 'search.svg',
  //     link: linkSet.buttonLink.appraisal,
  //   },
  //   {
  //     content: '현황조사서',
  //     icon: 'check.svg',
  //     link: statusServeryButtonOn ? `/statusServey?iidx=${caseInfo.iidx}` : '',
  //   },
  //   {
  //     content: '문건/송달내역',
  //     icon: 'letter.svg',
  //     link: deliveryButtonOn ? `/documentDetail?iidx=${caseInfo.iidx}` : '',
  //   },
  //   {
  //     content: '토지등기',
  //     icon: 'layer.svg',
  //     link: linkSet.buttonLink.landRegister,
  //   },
  //   {
  //     content: '첨부파일',
  //     icon: 'document.svg',
  //     link: '첨부파일',
  //   },
  // ];

  

  

  const PCommonList = [
    {
      refer: '온비드',
      title: '물건상세',
      color: '#FF7700',
      link: linkSet.detailLink.url,
    },
    {
      refer: '온비드',
      title: '입찰이력',
      color: '#FF7700',
      link: linkSet.detailLink.url1,
    },
    {
      refer: '온비드',
      title: '공고문',
      color: '#FF7700',
      link: linkSet.detailLink.url2,
    },
  ];

  const mapList = [
    {
      content: '전자지도',
      color: '#008AFF',
      link: type === 's' ? '' : `/fullSizeMap?type=map`,
    },
    {
      content: '전자지적도',
      color: '#008AFF',
      link: type === 's' ? '' : `/fullSizeMap?type=overlay`,
    },
    {
      content: '로드뷰',
      color: '#008AFF',
      link: type === 's' ? '' : `/fullSizeMap?type=roadView`,
    },
    { content: '씨:리얼지도+', color: '#FA4032', link: linkSet.serialLink },
    {
      content: '도시계획지도',
      color: '#FA4032',
      link: linkSet.landUsePlanLink,
    },
    { content: '토지이음지도', color: '#FA4032', link: linkSet.eumMapLink },
  ];

  const handleScroll = (sectionId: string) => {
    const element = document.getElementById(
      sectionId === '소재지' || sectionId === 'NPL 분석요약'
        ? type === 'a'
          ? 'printPage'
          : 'printPage'
        : sectionId,
    );

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleShare = () => {
    const currentUrl = window.location.href;
    navigator.clipboard
      .writeText(currentUrl)
      .then(() => {
        alert('URL이 복사되었습니다!');
      })
      .catch(() => {
        alert('URL 복사에 실패했습니다.');
      });
  };

  const handleOpacity = (item: any) => {
    if (item.content === '토지등기' || item.content === '건물등기') {
      return 0.2;
    }
    if (
      item.content !== '첨부파일' &&
      (item.link === '' || item.link === null)
    ) {
      return 0.2;
    }
    if (
      type === 'p' &&
      item.content === '첨부파일' &&
      attachmentFile.length < 0
    ) {
      return 0.2;
    }
    if (
      type === 'a' &&
      item.content === '첨부파일' &&
      (linkSet.buttonLink.assetDetail === '' ||
        linkSet.buttonLink.assetDetail === null) &&
      (linkSet.buttonLink.appraisal === '' ||
        linkSet.buttonLink.appraisal === null) &&
      (linkSet.buttonLink.statusSurvey === '' ||
        linkSet.buttonLink.statusSurvey === null) &&
      (linkSet.buttonLink.documentsHistory === '' ||
        linkSet.buttonLink.documentsHistory === null)
    ) {
      return 0.2;
    }
    if (type === 's') {
      return 0.2;
    } else {
      return 1;
    }
  };

  useEffect(() => {
    if (type === 's') {
      setList(ENaviInfo);
    }
    if (type === 'a') {
      tab === 'npl' ? setList(NNaviInfo) : setList(ANavInfo);
    }
    if (type === 'p') {
      setList(PNavInfo);
    }
  }, [type]);

  useEffect(() => {
    const updatePositions = () => {
      const newPositions = list.map((id) => {
        const element = document.getElementById(
          id === '소재지' ? 'printPage' : id,
        );

        if (element) {
          // console.log(id, element.getBoundingClientRect().top + window.scrollY);
        }
        return element
          ? Math.floor(element.getBoundingClientRect().top) + window.scrollY
          : 0;
      });
      setPositions(newPositions);
    };

    updatePositions();
    window.addEventListener('resize', updatePositions);
    return () => window.removeEventListener('resize', updatePositions);
  }, [list, type]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      let currentIndex = 0;

      if (scrollY === 0) {
        setActiveIndex(0);
        return;
      }

      for (let i = 0; i < positions.length - 1; i++) {
        const nextPosition =
          positions[i + 1] === 0 ? positions[i + 2] : positions[i + 1];
        if (scrollY >= positions[i] && scrollY < nextPosition) {
          currentIndex = i;
          break;
        }
      }

      if (scrollY >= positions[positions.length - 1]) {
        currentIndex = positions.length - 1;
      }

      if (scrollY + window.innerHeight >= document.body.scrollHeight - 10) {
        currentIndex = positions.length - 1;
      }

      setActiveIndex(currentIndex);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [positions]);

  // const renderDateBox = () => {
  //   if (type === 'a') {
  //     return (
  //       <InfoBox>
  //         <InfoItem>
  //           <span>개시결정</span>
  //           <InfoText>{caseInfo?.date?.start_date?.split(': ')[1]}</InfoText>
  //         </InfoItem>
  //         <InfoItem>
  //           <span>배당요구종기일</span>
  //           <InfoText>{caseInfo?.date?.div_date?.split(': ')[1]}</InfoText>
  //         </InfoItem>
  //         <InfoItem>
  //           {caseInfo.bid === '매각' || caseInfo.bid === '낙찰' ? (
  //             <>
  //               <span>매각결정기일</span>
  //               <InfoText saleYN={true}>{caseInfo?.saleDate}</InfoText>
  //             </>
  //           ) : (
  //             <>
  //               <span>경매시작일</span>
  //               <InfoText>
  //                 D
  //                 {caseInfo?.date?.remaining_days > 0
  //                   ? `-${caseInfo?.date?.remaining_days}`
  //                   : `+${Math.abs(caseInfo?.date?.remaining_days)}`}
  //               </InfoText>
  //             </>
  //           )}
  //         </InfoItem>
  //       </InfoBox>
  //     );
  //   }
  //   if (type === 's') {
  //     return (
  //       <InfoBox>
  //         <InfoItem>
  //           <span>사건접수</span>
  //           <InfoText>{caseInfo?.date?.reg_date?.split('T')[0]}</InfoText>
  //         </InfoItem>
  //         <InfoItem>
  //           <span>배당요구종기일</span>
  //           <InfoText>{caseInfo?.date?.div_date?.split('T')[0]}</InfoText>
  //         </InfoItem>
  //         <InfoItem>
  //           <span>경매개시일</span>
  //           <InfoText style={{ color: '#f45551', backgroundColor: '#FFEFEF' }}>
  //             {caseInfo?.date?.dec_date?.split('T')[0]}
  //           </InfoText>
  //         </InfoItem>
  //       </InfoBox>
  //     );
  //   } else {
  //     return null;
  //   }
  // };

  const Aoutlink = [
    {
      img: '/assets/images/icon/icon_landUse.svg',
      title: '토지이음',
      subTitle: '토지이용계획열람',
      link: linkSet.landUsePlanLink,
    },
    {
      img: '/assets/images/icon/icon_court.svg',
      title: '대한민국 법원',
      subTitle: '법원경매정보',
      link: 'https://www.courtauction.go.kr/pgj/index.on',
    },
    {
      img: '/assets/images/icon/icon_naverLand.svg',
      title: '네이버페이 부동산',
      subTitle: '네이버 매물',
      link: '',
    },
    {
      img: '/assets/images/icon/icon_naverLand.svg',
      title: '네이버페이 부동산',
      subTitle: '네이버 단지정보',
      link: linkSet?.naverComplexLink,
    },
  ];


const attachmentIcon = '/assets/images/icon/Icon_Attachment.svg';
  return (
    <SideInfoContainer className="noprint">
      <SideInfoWrap>
     
        {/* {renderDateBox()} */}
      <SBox>
  {(() => {
    const list =
      type === 'a' || type === 's'
        ? AFileList(linkSet, caseInfo, statusServeryButtonOn, deliveryButtonOn)
        : PFileList(linkSet);

    const targetItem = list.find((item) => item.content === '현황조사서');

    if (!targetItem) return null;
    const isHidden = !targetItem.link;
    return (
      <div
        style={{
          opacity: handleOpacity(targetItem),
    background: 'none'
  }}
        onClick={() => {
          if (type !== 'e') {
            if (targetItem.content === '첨부파일') {
              setShowFileModal(true);
            } else if (targetItem.link) {
              window.open(targetItem.link);
            }
          }
        }}
      >
        <div style={{display:'flex', gap:'2px', cursor:'pointer' }}>
        <img src={attachmentIcon} alt="" />
        <SButton2
          content={targetItem.content}
          style={{
            background: 'none',
            border:'none',
            fontSize: '14px',
            fontWeight:'500',
            color: '#008AFF',
            padding: 0
           }} />
        </div>
        </div>
    );
  })()}
</SBox>
      </SideInfoWrap>
    </SideInfoContainer>
  );
};

export default SideInfo;

// const OutLinkContent = styled.div`
//   width: 100%;
//   flex-direction: column;
// `;

// const OutLinkContentBox = styled.div`
//   display: flex;
//   flex-direction: row;
//   gap: 6px;
//   align-items: center;
// `;

// const OutLinkBox = styled.div`
//   width: 100%;
//   height: 100%;
//   display: flex;
//   flex-direction: row;
//   justify-content: space-between;
//   align-items: center;
//   padding: 12px 16px;
//   border: 1px solid #e5e8ea;
//   border-radius: 4px;
//   cursor: pointer;
// `;

// const OutLinkContainer = styled.div`
//   width: 100%;
//   height: 100%;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   gap: 8px;

//   color: #222222;
//   font-size: 12px;
//   font-family: Spoqa Han Sans Neo;
//   font-weight: 700;
//   line-height: 17.4px;
//   word-wrap: break-word;
//   span {
//     color: #0052bd;
//     font-size: 9px;
//     font-family: Spoqa Han Sans Neo;
//     font-weight: 500;
//     line-height: 13.05px;
//     word-wrap: break-word;
//   }
// `;



export const SWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding-block: 8px;
  border-block: 1px solid var(--Alias-Color-Text-White-BlueGray-600, #5e7188);
  margin-bottom: 50px;
`;

interface SItemProps {
  isActive: boolean;
  noData: boolean;
}

export const SItemBox = styled.div<SItemProps>`
  /* display: flex;
  flex-direction: row; */
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 8px 16px;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  line-height: 17.4px;
  letter-spacing: -0.05em;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: ${(props) => (props.isActive ? '#008AFF' : '#171e268f')};
  background-color: ${(props) => (props.isActive ? '#F0F8FF' : 'white')};
  border-radius: 8px;

  color: ${(props) => (props.noData ? '#fff' : '')};
  background-color: ${(props) => (props.noData ? '#f0f0f0' : '')};
  pointer-events: ${(props) => (props.noData ? 'none' : 'auto')};
  cursor: ${(props) => (props.noData ? 'not-allowed' : 'pointer')};
  img {
    width: 24px;
    height: 24px;
  }
`;

// const InfoBox = styled.div`
//   width: 100%;
//   padding: 8px 8px 16px 8px;
//   display: flex;
//   flex-direction: row;
//   justify-content: space-between;
//   border-bottom: 1px solid #f0f0f0;
// `;
// const InfoItem = styled.div`
//   font-family: Spoqa Han Sans Neo;
//   font-size: 12px;
//   font-style: normal;
//   font-weight: 500;
//   color: rgba(23, 30, 38, 0.78);
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   gap: 12px;
// `;

// interface InfoTextProps {
//   saleYN?: boolean;
// }

// const InfoText = styled.span<InfoTextProps>`
//   padding: 4px 8px;
//   border-radius: 6px;
//   background: #e6f3ff;
//   color: ${(props) => (props.saleYN ? '#f45551' : '#008aff')};
//   background-color: ${(props) => (props.saleYN ? '#ffefef' : '#e6f3ff')};
// `;

// const TopButtonBox = styled.div`
//   width: 100%;
//   display: flex;
//   flex-direction: row;
//   align-items: center;
//   gap: 8px;
//   padding: 4px;
//   border: 1px solid #e5e8ea;
//   border-radius: 10px;
// `;

// const TopButtonItem = styled.div`
//   flex: 1;
//   height: 26px;
//   display: flex;
//   flex-direction: row;
//   gap: 4px;
//   justify-content: center;
//   align-items: center;
//   font-size: 14px;
//   font-family: Spoqa Han Sans Neo;
//   font-weight: 500;
//   border-radius: 8px;
//   cursor: pointer;
//   color: #616161;

//   img {
//     width: 16px;
//     height: 16px;
//   }
// `;
// const Divider = styled.div`
//   width: 1px;
//   height: 12px;
//   background-color: rgba(112, 115, 124, 0.16);
// `;